function initProductSwiper() {
  var productSwiper = new Swiper('.u-product-slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1200: { slidesPerView: 4 },
      992: { slidesPerView: 3 },
      768: { slidesPerView: 2 },
      250: { slidesPerView: 1 }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');
    
    if (!doubleuspsElement) {
      console.error('Error: .doubleusps element not found');
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;
    
    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});



function updateInventoryNumber(variantId, container, forceNew = false) {
  const span = container.querySelector(".u-number");
  if (!span) return;

  const storageKey = "u-number_" + variantId;
  let storedValue = localStorage.getItem(storageKey);

  if (forceNew || !storedValue) {
    const min = parseInt(span.dataset.min) || 3;
    const max = parseInt(span.dataset.max) || 9;

    storedValue = Math.floor(Math.random() * (max - min + 1)) + min;
    localStorage.setItem(storageKey, storedValue);
  }

  span.textContent = storedValue;
}

function initInventoryBlocks(forceNew = false) {
  document.querySelectorAll(".uinventory-box").forEach((container) => {
    const variantId = container.dataset.variantId;
    if (variantId) {
      updateInventoryNumber(variantId, container, forceNew);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initInventoryBlocks();

  document.addEventListener("click", function (e) {
    if (e.target.closest(".variant__button-label")) {
      setTimeout(() => {
        initInventoryBlocks(true); // force new random number
      }, 100);
    }
  });
});
